import React from 'react'
import { Grid, InputBaseProps, TextField } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import { UseFormGetValues, UseFormRegister, Controller } from 'react-hook-form'

interface CrudNumberFieldProps {
  readonly register: UseFormRegister<any>
  readonly model: string
  readonly getValues?: UseFormGetValues<any> // getValues opcional
  readonly control: any // Control do react-hook-form
  readonly placeholder?: string
  readonly min?: number
  readonly max?: number
  readonly required?: boolean
}

export default function CrudNumberField(props: CrudNumberFieldProps) {
  const { translate } = useLang()
  const {
    register,
    model,
    getValues,
    control,
    placeholder,
    min,
    max = 0,
    required = false,
  } = props

  const inputProps: InputBaseProps['inputProps'] = {
    inputMode: 'numeric',
    pattern: '[0-9]*',
    min: min ?? 0,
    type: 'number',
  }

  if (max) {
    inputProps['max'] = max
  }

  return (
    <Grid item xs={4}>
      <Controller
        name={model}
        control={control}
        defaultValue={
          typeof getValues === 'function' ? getValues(model) ?? null : null
        }
        rules={{
          required: required ? translate(`Fill the ${model} field.`) : false,
          min:
            min !== undefined
              ? {
                  value: min,
                  message: translate(`Value must be at least ${min}`),
                }
              : undefined,
          max: max
            ? { value: max, message: translate(`Value must not exceed ${max}`) }
            : undefined,
        }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            required={required}
            label={translate(
              `${
                placeholder
                  ? placeholder.charAt(0).toUpperCase() + placeholder.slice(1)
                  : model.charAt(0).toUpperCase() + model.slice(1)
              }`
            )}
            margin="normal"
            fullWidth
            type="number"
            sx={{ mt: 0 }}
            inputProps={inputProps}
            InputLabelProps={{
              shrink:
                field.value !== undefined &&
                field.value !== null &&
                field.value !== '',
            }}
            onChange={(e) => {
              const value = e.target.value ? Number(e.target.value) : null
              field.onChange(value)
            }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </Grid>
  )
}
